import type { ReactNode } from "react";

export interface FrameTopBarProps {
  children: ReactNode;
  /** Whether the top bar pins to the viewport top.
   *
   *  - `true` (default): sticky on all viewports.
   *  - `false`: sticky on mobile only — scrolls away with content on `md+`. Use on
   *    pages with a full-bleed desktop decoration (e.g. the profile swoosh) so the
   *    bar moves with the page on desktop instead of letting content slide behind it.
   *
   *  Mobile is always sticky: the mobile top bar typically carries back-button or
   *  page context that needs to stay reachable mid-scroll. */
  sticky?: boolean;
}

/**
 * Top chrome region. Full width, z-40. Sticky to the viewport top by default.
 * Frame doesn't care if the contents are a mobile or desktop top bar — the
 * consumer composes whatever it wants inside.
 */
export function FrameTopBar({ children }: FrameTopBarProps) {
  return <>{children}</>;
}
